/**
 * Mirrors HRDP.Contracts.Messages.WorkerChangeType (.NET).
 * Numeric values must stay in sync with the backend enum.
 */
export enum WorkerChangeTypeEnum {
    Created = 1,
    Updated = 2,
    Deleted = 3,
    StatusChanged = 4,
    InstitutionChanged = 5,
    Imported = 6,
    ManualTrigger = 7
}
